module.exports = __webpack_public_path__ + "img/card-img1.a3706d72.png";